import React from 'react';
import '../styles/AboutPage.css';
//import Lottie from 'lottie-react';
//import anime1 from '../animations/anime5.json';

const HistoryPage = () => {
    return (
        <div className="about-container">
            {/* Hero
            <section className="about-hero">
                <div className="overlay"></div>
                <div className="about-hero-content">
                    <Lottie animationData={anime1} loop={true} className="about-animation"
                            style={{width: '75%', height: '75%'}}/>

                </div>
            </section>*/}

            {/* Content Sections */}
            <section className="about-section">
                <div className="about-content">

                    <h2>Tarihçe</h2>
                    <section id="meduvr-tarihce">
                        <p>
                            <strong>MeduVR</strong>, sağlık eğitimi alanında sanal gerçeklik (VR) tabanlı dijital
                            çözümler üretmek amacıyla
                            Doç. Dr. Nuran Akyurt öncülüğünde geliştirilmiş, Türkiye'nin ilk ve öncü VR destekli tıbbi
                            eğitim platformudur.
                            Girişimin gelişim süreci, akademik araştırmalarla başlayıp ulusal/uluslararası destek
                            programları, Ar-Ge projeleri
                            ve ticarileştirme faaliyetleriyle çok boyutlu bir yapıya ulaşmıştır.
                        </p>

                        <h3>📅 2018 – Akademik Temellerin Atılması</h3>
                        <p>
                            Marmara Üniversitesi Bilimsel Araştırma Projeleri Koordinatörlüğü (BABKO) tarafından
                            desteklenen
                            “Tıbbi Görüntüleme Teknikleri Eğitiminde Sanal Gerçeklik” başlıklı proje ile MeduVR'nin
                            bilimsel ve metodolojik altyapısı oluşturulmuştur.
                            Bu proje, VR tabanlı simülasyonların sağlık eğitiminde uygulanabilirliğini gösteren ilk
                            kurumsal adımdır.
                        </p>

                        <h3>📅 2019 – Ürünleştirme ve Ticarileşme Süreci</h3>
                        <p>
                            RSG’nin yenilikçi içeriklerinin ürünleştirilmesi ve ticarileştirilmesi süreci, Marmara
                            Üniversitesi Teknoloji Transfer Ofisi (MİTTO) koordinasyonunda yürütülmüştür.
                            Bu kapsamda fikri mülkiyet yönetimi, girişimcilik eğitimi ve pazara giriş stratejileri
                            alanında alınan desteklerle, proje akademik çerçevenin dışına çıkarılarak ticarileşebilir
                            bir yapıya dönüştürülmüştür.
                        </p>

                        <h3>📅 2020 – Bayer G4A Türkiye Açık İnovasyon Programı</h3>
                        <p>
                            Bayer G4A programı kapsamında kabul edilen proje ile, radyolojide VR teknolojisi
                            aracılığıyla X-ışını üretmeden sanal ortamda görüntüleme pratiği kazandırmaya yönelik bir
                            eğitim çözümü geliştirilmiştir.
                            Bu süreç, VR teknolojisinin yalnızca mamografide değil, tüm radyoloji eğitimi alanlarında
                            nasıl kullanılabileceği konusunda önemli deneyimler sağlamıştır.
                        </p>

                        <h3>📅 2021 – Ar-Ge Firmasının Kurulması</h3>
                        <p>
                            RSG Bilgi Teknolojileri Sağlık ve İnovasyon Ltd. Şti., Doç. Dr. Nuran Akyurt’un
                            kuruculuğunda Marmara Üniversitesi Teknopark bünyesinde kurulmuştur.
                            Firma, MeduVR platformunun sürdürülebilirliğini sağlamak, dijital sağlık çözümleri
                            geliştirmek ve Ar-Ge projelerini ürünleştirmek amacıyla faaliyetlerine başlamıştır.
                        </p>

                        <h3>📅 2022 – KOSGEB Destekli Girişimcilik</h3>
                        <p>
                            KOSGEB İleri Girişimci Destek Programı kapsamında alınan destekle, RSG ve MeduVR'nin ürün
                            portföyü genişletilmiş;
                            kadın girişimciliği ve dijital sağlık uygulamaları alanında yenilikçi projeler hayata
                            geçirilmiştir.
                        </p>

                        <h3>📅 2022 – Marka Tescili ve Kalite Odaklı Gelişim</h3>
                        <p>
                            2022 yılında, Radyolojide Sanal Gerçeklik markası için Türk Patent ve Marka Kurumu nezdinde
                            marka tescil süreci tamamlanmış,
                            girişimin fikri ve sınai mülkiyet hakları resmiyet kazanmıştır.
                            Aynı yıl, kalite süreçlerinin yapılandırılması kapsamında TÜRKAK (Türk Akreditasyon Kurumu)
                            standartları ve izlenebilirlik ilkeleri doğrultusunda kurumsallaşma adımları atılmıştır.
                            Bu süreç, MeduVR'nin yalnızca ürün değil, kalite güvencesi sunan bir sağlık eğitimi markası
                            olarak konumlanmasına katkı sağlamıştır.
                        </p>

                        <h3>📅 2023 – ADEP Kapsamında Stratejik Proje Desteği</h3>
                        <p>
                            Cumhurbaşkanlığı Strateji ve Bütçe Başkanlığı ile Yükseköğretim Kurulu (YÖK) iş birliğiyle
                            yürütülen Araştırma Üniversiteleri Destek Programı (ADEP) kapsamında,
                            Doç. Dr. Nuran Akyurt’un yürütücülüğünü üstlendiği “Sanal Gerçeklik Teknolojisi ile Meme
                            Kanseri Erken Tanı ve Tarama Prototipinin Geliştirilmesi” başlıklı proje desteklenmeye hak
                            kazanmıştır.
                            Bu projeyle, VR tabanlı uygulamalar; meme sağlığına yönelik, sağlık çalışanlarının halk
                            sağlığı temelli erken tanı ve farkındalık kazandırıcı eğitim modüllerine dönüştürülmüştür.
                        </p>

                        <h3>📅 2018–2025 – Disiplinlerarası Araştırma Deneyimi (TÜBİTAK Programları)</h3>
                        <p>
                            Proje ekibinde yer alan araştırmacılar, TÜBİTAK 1002-B, 2242 ve 2247-C STAR programları
                            aracılığıyla;
                            yapay zekâ, halk sağlığı, sağlık çalışanlarının eğitimi, sağlık teknolojileri ve disiplinler
                            arası eğitim alanlarında projelerde aktif görev almış;
                            böylece MeduVR’nin içerik geliştirme kapasitesine önemli akademik katkı sağlamışlardır.
                        </p>

                        <h3>📅 2023 – Marmara Üniversitesi Teknopark’ta Ar-Ge ve Ürünleştirme</h3>
                        <p>
                            MeduVR girişimi, Marmara Üniversitesi Teknopark’ta yürütülen projeler aracılığıyla dijital
                            sağlık teknolojilerinin ürünleştirilmesi, prototip üretimi, test edilmesi ve
                            yaygınlaştırılması süreçlerinde önemli birikim ve deneyim kazanmıştır.
                        </p>

                        <h3>🔍 Genel Değerlendirme – Nitelikli Girişimcilik ve Etki</h3>
                        <p>
                            MeduVR, eğitimde dijitalleşme, kadın girişimciliği, yapay zekâ, sağlık eğitimi, sağlık
                            teknolojileri ve halk sağlığı gibi stratejik alanlarda yürütülen çok paydaşlı projelerle
                            yalnızca bir ürün değil; toplumsal katkı sağlayan, sürdürülebilir, yenilikçi bir dijital
                            eğitim modeli olarak öne çıkmaktadır.
                        </p>
                    </section>


                    <h2>Öne Çıkan Özelliklerimiz</h2>
                    <ul>
                        <li>Türkiye’nin ilk ve tek sanal gerçeklik tabanlı tıbbi eğitim platformu</li>
                        <li>Meme sağlığı ve meme kanserinde erken teşhis konusunda farkındalık yaratan yenilikçi eğitim
                            içerikleri
                        </li>
                        <li>Kendi kendine meme muayenesi (KKMM) ve mamografi öncesi uygulamalı eğitim senaryoları</li>
                        <li>Sanal gerçeklik destekli simülasyonlarla yerden ve zamandan bağımsız eğitim deneyimi</li>

                        <li>Kullanıcıya defalarca tekrar edilebilir, güvenli ve etkileşimli bir öğrenme ortamı sunma
                        </li>

                        <li>Tıbbi Görüntüleme Teknikleri öğrencileri, sağlık profesyonelleri ve halk için
                            yapılandırılmış modüller
                        </li>

                        <li>Kadın girişimciliğini ve dijital sağlık çözümlerini destekleyen çok paydaşlı projeler</li>
                        <li>ADEP, TÜBİTAK, KOSGEB, BABKO, Bayer G4A gibi ulusal ve uluslararası programlardan alınan
                            destekler
                        </li>
                        <li>Marmara Üniversitesi Teknopark bünyesinde sürdürülen Ar-Ge, ürünleştirme ve kalite odaklı
                            gelişim süreçleri
                        </li>
                    </ul>
                </div>
            </section>
        </div>
    );
};

export default HistoryPage;